import { number, object, ObjectSchema, string } from 'yup';

import { CadastralValue } from '@client/api';

const schema: ObjectSchema<CadastralValue> = object({
  cadastralUnit: string().nullable(),
  propertyUnit: string().nullable(),
  leaseholdUnit: string().nullable(),
  sectionUnit: string().nullable(),
  constructionYear: number().positive().integer().nullable()
});

export { schema as cadastralValueSchema };
